import { useEffect, useState } from "react";
import { useLang } from "@/i18n";

// Eröffnungsdatum: 01.09.2026 00:00 Europe/Berlin (CEST = UTC+2)
const OPENING = new Date("2026-09-01T00:00:00+02:00").getTime();

const diffParts = (ms) => {
  if (ms <= 0) return { d: 0, h: 0, m: 0, s: 0 };
  const s = Math.floor(ms / 1000);
  return {
    d: Math.floor(s / 86400),
    h: Math.floor((s % 86400) / 3600),
    m: Math.floor((s % 3600) / 60),
    s: s % 60,
  };
};

export const Countdown = () => {
  const { t } = useLang();
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (Date.now() >= OPENING) return;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  if (now >= OPENING) return null;

  const { d, h, m, s } = diffParts(OPENING - now);
  const cells = [
    { v: d, k: "countdown.days" },
    { v: h, k: "countdown.hours" },
    { v: m, k: "countdown.minutes" },
    { v: s, k: "countdown.seconds" },
  ];

  return (
    <div data-testid="countdown" className="mt-6 mb-8 flex items-stretch gap-3 max-w-md">
      {cells.map((c, i) => (
        <div key={c.k} className="flex-1 flex flex-col items-center justify-center border border-primary/30 bg-primary/5 py-3">
          <span className="font-serif text-3xl md:text-4xl leading-none tabular-nums text-primary">
            {String(c.v).padStart(2, "0")}
          </span>
          <span className="mt-1 text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
            {t(c.k)}
          </span>
        </div>
      ))}
    </div>
  );
};
